import { types } from 'mobx-state-tree'
import { IdNamePair } from './collection'

export const MaskingValues = types.model({
   firstName: types.optional(types.array(IdNamePair), []),
   lastName: types.optional(types.array(IdNamePair), []),
   accountNumber: types.optional(types.array(IdNamePair), []),
})
